import {Box, Text, Flex, Image, keyframes, Tooltip} from '@chakra-ui/react'
import LocationIcon from '@assets/svgs/lern-part-three/location.svg'
import StarIcon from '@assets/svgs/lern-part-three/star.svg'
import FlagIcon from '@assets/svgs/lern-part-three/flag.svg'
import {CommonColors} from '@utils/CommonStyles'
import {useSelector} from 'react-redux'

const slideUp = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`

const Intro = () => {
  const {currentContent} = useSelector((state: any) => state.learnPartThree)

  return (
    <Box>
      <Text
        color={'#667085'}
        fontSize={'18px'}
        textTransform={'uppercase'}
        align={'center'}>
        {currentContent?.data?.title}
      </Text>
      <Flex mt={'24px'} justifyContent={'center'}>
        <Flex flexDirection={'column'} gap={'8px'}>
          <Flex
            className={'outline-item'}
            gap={'16px'}
            animation={`${slideUp} 0.5s ease-out forwards`}
            style={{opacity: 0}}>
            <Flex
              flexDirection={'column'}
              minH={'100px'}
              alignItems={'center'}
              gap={'8px'}>
              <Image
                src={LocationIcon}
                alt="flag"
                width={'48px'}
                height={'48px'}
              />
              <Box flex={1} w={'2px'} bg={'#E4E7EC'} />
            </Flex>
            <Flex flexDirection={'column'}>
              <Text fontSize={'16px'} fontWeight={'600'}>
                {currentContent?.data?.idea_frame?.open?.header}
              </Text>
              <Text fontSize={'16px'} color={'#475467'}>
                {currentContent?.data?.idea_frame?.open?.content}
              </Text>
            </Flex>
          </Flex>
          {currentContent?.data?.idea_frame?.main_ideas?.map(
            (item: any, index: number) => (
              <Flex
                key={index}
                className={'outline-item'}
                gap={'16px'}
                animation={`${slideUp} 0.5s ease-out forwards`}
                style={{
                  opacity: 0,
                  animationDelay: `${(index + 1) * 0.4}s`,
                }}>
                <Flex
                  flexDirection={'column'}
                  minH={'100px'}
                  alignItems={'center'}
                  gap={'8px'}>
                  <Image
                    src={StarIcon}
                    alt="flag"
                    width={'48px'}
                    height={'48px'}
                  />
                  <Box flex={1} w={'2px'} bg={'#E4E7EC'} />
                </Flex>
                <Flex flexDirection={'column'}>
                  <Text fontSize={'16px'} fontWeight={'600'}>
                    {item?.header}
                  </Text>
                  <Flex gap={'8px'} alignItems={'center'}>
                    <Text fontSize={'16px'} color={'#475467'}>
                      {item?.linking_phrase}
                    </Text>
                    <Tooltip
                      label={item?.block_statement?.popup}
                      placement="top"
                      hasArrow>
                      <Text
                        cursor={'pointer'}
                        as={'span'}
                        fontWeight={'500'}
                        color={CommonColors.primary}
                        bg={'#D6EBFF'}
                        borderRadius={'100px'}
                        px={'12px'}
                        py={'4px'}
                        border={'1px solid #99CEFF'}>
                        {item?.block_statement?.text}
                      </Text>
                    </Tooltip>
                    <Text as={'span'} color={'#99CEFF'}>
                      +
                    </Text>
                    <Tooltip
                      label={item?.block_explanation?.popup}
                      placement="top"
                      hasArrow>
                      <Text
                        cursor={'pointer'}
                        as={'span'}
                        fontWeight={'500'}
                        color={CommonColors.primary}
                        bg={'#D6EBFF'}
                        borderRadius={'100px'}
                        px={'12px'}
                        py={'4px'}
                        border={'1px solid #99CEFF'}>
                        {item?.block_explanation?.text}
                      </Text>
                    </Tooltip>
                  </Flex>
                </Flex>
              </Flex>
            ),
          )}
          <Flex
            className={'outline-item'}
            gap={'16px'}
            animation={`${slideUp} 0.5s ease-out forwards`}
            style={{
              opacity: 0,
              animationDelay: `${(currentContent?.data?.idea_frame?.main_ideas?.length + 1) * 0.4}s`,
            }}>
            <Flex
              flexDirection={'column'}
              minH={'100px'}
              alignItems={'center'}
              gap={'8px'}>
              <Image src={FlagIcon} alt="flag" width={'48px'} height={'48px'} />
            </Flex>
            <Flex flexDirection={'column'}>
              <Text fontSize={'16px'} fontWeight={'600'}>
                {currentContent?.data?.idea_frame?.close?.header}
              </Text>
              <Text fontSize={'16px'} color={'#475467'}>
                {currentContent?.data?.idea_frame?.close?.content}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Intro
